import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Attribution } from '../models/Attribution';

@Component({
  selector: 'app-attribution',
  templateUrl: './attribution.component.html'
})
export class AttributionComponent implements OnInit {

  @Input() uid = '';
  public current_uid = 'Attribution';
  @Input() parentForm: FormGroup;
  @Input() attribution: Attribution;

  constructor() {
  }

  public ngOnInit() {
  }

  public getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  }
}
